export default __webpack_public_path__ + "static/media/Manrope-Medium.c1117ffc.ttf";